import { useState, type KeyboardEvent } from 'react';

import { getStudentEmailDomain } from '../../api/environment';
import { featureEnabled } from '../../config/features';
import { ExamsPanel, type ExamsPanelProps } from '../exams/ExamsPanel';
import { SubmissionsPanel, type SubmissionsPanelProps } from './SubmissionsPanel';

type ClassWorkTab = 'homework' | 'exams';

const TABS: Array<{ id: ClassWorkTab; label: string }> = [
  { id: 'homework', label: 'Bài tập' },
  { id: 'exams', label: 'Bài kiểm tra' },
];

export interface ClassWorkPanelProps extends Pick<ExamsPanelProps, 'classId' | 'gradeId' | 'subjectId'> {
  classTitle: string;
  onOpenSubmission: SubmissionsPanelProps['onOpen'];
  onOpenExam: (examId: string) => void;
}

// Bài nộp: homework the class handed in, and the IZ exams it sat; the exam tab exists only with a data source
export function ClassWorkPanel({ classTitle, classId, gradeId, subjectId, onOpenSubmission, onOpenExam }: ClassWorkPanelProps) {
  const [tab, setTab] = useState<ClassWorkTab>('homework');
  if (!featureEnabled('board.examResults') || !getStudentEmailDomain()) return <SubmissionsPanel classTitle={classTitle} onOpen={onOpenSubmission} />;

  function onKey(event: KeyboardEvent<HTMLButtonElement>) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    setTab(tab === 'homework' ? 'exams' : 'homework');
  }

  return (
    <>
      <div className="up-tabs hw-tabs" role="tablist" aria-label="Loại bài nộp">
        {TABS.map((item) => (
          <button key={item.id} type="button" role="tab" id={`classwork-tab-${item.id}`} aria-selected={tab === item.id} aria-controls="classwork-tabpanel" tabIndex={tab === item.id ? 0 : -1} className={tab === item.id ? 'is-active' : ''} onKeyDown={onKey} onClick={() => setTab(item.id)}>{item.label}</button>
        ))}
      </div>
      <div role="tabpanel" id="classwork-tabpanel" aria-labelledby={`classwork-tab-${tab}`}>
        {tab === 'homework' ? <SubmissionsPanel classTitle={classTitle} onOpen={onOpenSubmission} /> : <ExamsPanel classTitle={classTitle} classId={classId} gradeId={gradeId} subjectId={subjectId} onOpen={onOpenExam} />}
      </div>
    </>
  );
}
